/**
 * Reactive feature-flag accessor pour le système de configuration
 * multi-agences (cascade enterprise → station). Source unique de vérité
 * pour l'activation/désactivation des modules côté UI.
 *
 *   const { enabled, value, source } = useFeatureFlag('module.tickets');
 *   if (enabled.value) { ... }
 */
import { computed, ComputedRef } from "vue";
import { featuresMap, FeatureSource } from "@/state/api/featuresState";

export interface UseFeatureFlag {
	enabled: ComputedRef<boolean>;
	value: ComputedRef<any>;
	source: ComputedRef<FeatureSource>;
}

export function useFeatureFlag(key: string): UseFeatureFlag {
	return {
		enabled: computed(() => !!featuresMap.value[key]?.enabled),
		value: computed(() => featuresMap.value[key]?.value ?? null),
		source: computed(() => featuresMap.value[key]?.source ?? "unknown"),
	};
}

export function isFeatureFlagEnabled(key: string): boolean {
	return !!featuresMap.value[key]?.enabled;
}

export function getFeatureFlagValue<T = any>(key: string, fallback: T | null = null): T | null {
	const v = featuresMap.value[key]?.value;
	return v == null ? fallback : (v as T);
}
